<template>
  <div class="contact-page text-neutral-800 py-12 lg:pt-10 lg:pb-20">
    <NuxtLink
      class="inline-flex items-center focus:outline-none ota-body-light"
      :to="{ path: $i18n.localePath({ name: 'customer-service' }) }"
    >
      <OSvg svg="arrow-left" class="w-3 fill-gray-600 pt-1" />
      <span v-text="$t('FAQ.BackToOverview')" />
    </NuxtLink>
    <h1 class="o-heading-1 my-3" v-text="$t('ContactPage.Title')" />
    <p class="o-body" v-text="$t('ContactPage.Description')" />
    <ContactPageSection
      class="mt-8 bg-neutral-50"
      :title="$t('ContactPage.Sections.CustomerQuestions.Title')"
      :body="$t('ContactPage.Sections.CustomerQuestions.Description')"
    >
      <NewButton tag="a" :href="chatbotLink" class="text-white" icon-right="new-chevron-right">
        {{ $t('ContactPage.Sections.CustomerQuestions.CTA') }}
      </NewButton>
    </ContactPageSection>
    <ContactPageSection
      class="mt-8"
      :title="$t('ContactPage.Sections.PressQuestions.Title')"
      :body="$t('ContactPage.Sections.PressQuestions.Description')"
    >
      <NewButton
        tag="a"
        :href="pressEmailLink"
        variant="outline"
        color="blue"
        class="text-white"
        icon-right="new-chevron-right"
      >
        {{ $t('ContactPage.Sections.PressQuestions.CTA') }}
      </NewButton>
    </ContactPageSection>
    <ContactPageSection
      class="mt-8 bg-neutral-50"
      :title="$t('ContactPage.Sections.GeneralQuestions.Title')"
      :body="$t('ContactPage.Sections.GeneralQuestions.Description')"
    >
      <NewButton
        tag="a"
        :href="corporateEmailLink"
        variant="outline"
        color="blue"
        class="text-white"
        icon-right="new-chevron-right"
      >
        {{ $t('ContactPage.Sections.GeneralQuestions.CTA') }}
      </NewButton>
    </ContactPageSection>
    <ContactPageSection
      class="mt-8"
      :title="$t('ContactPage.Sections.VacancyQuestions.Title')"
      :body="$t('ContactPage.Sections.VacancyQuestions.Description')"
    >
      <NewButton
        variant="outline"
        tag="a"
        :href="jobsLink"
        color="blue"
        class="text-white"
        icon-right="new-chevron-right"
      >
        {{ $t('ContactPage.Sections.VacancyQuestions.CTA') }}
      </NewButton>
    </ContactPageSection>
    <ContactPageSection
      class="mt-8 bg-neutral-50"
      :title="$t('ContactPage.Sections.WhyNoPhoneNumberQuestions.Title')"
      :body="$t('ContactPage.Sections.WhyNoPhoneNumberQuestions.Description')"
    />
    <div class="py-20 mt-10">
      <ContactBlock :locale="locale" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContactBlock from '@/components/ContactBlock'
import ContactPageSection from '@/components/ContactPageSection'
import OSvg from '@/components/OSvg'
import NewButton from '@/components/NewButton'

export default {
  name: 'ContactPage',
  layout: 'homepage',
  components: { ContactBlock, OSvg, ContactPageSection, NewButton },
  computed: {
    chatbotLink () {
      return `${process.env.CHATBOT_BASE_URL}/${this.locale}`
    },
    pressEmailLink () {
      return `mailto:${this.$t('General.Email.Press')}`
    },
    corporateEmailLink () {
      return `mailto:${this.$t('General.Email.Corporate')}`
    },
    jobsLink () {
      return this.$t('FooterLinks.VacanciesLink')
    },
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  head () {
    return {
      title: this.$t('ContactPage.Meta.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('ContactPage.Meta.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.contact-page {
  @apply px-3 mx-auto;
  max-width: 97.5rem;
}
</style>
